import { useState, useRef } from 'react'
import Button from 'react-bootstrap/Button';
import { Floppy2Fill } from 'react-bootstrap-icons';
import TextField from '@mui/material/TextField';
import { inputProps } from '../muiStyles/muiInput';
import context from './context/shared';
import { centerClient } from '../../shared/clients';
import type { Account, Account as AccountDto } from '../../shared/generated';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useIsMobile } from '../shared';
import { Settings } from '@mui/icons-material';
import { Dropdown } from 'rsuite';

const AccountInfo = ({ account, setAccount }) => {
    const saveTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const [saveText, setSaveText] = useState("");
    const { refreshTree } = context;
    const handleSaveAccount = (accToSave) => {
        setSaveText("");
        setSaveButtonDisabled(false);
        clearTimeout(saveTimeoutRef.current);
        saveTimeoutRef.current = setTimeout(() => {
            saveAccount(accToSave);
        }, 3000);
    }
    const successSaveAccount = () => {
        setSaveButtonDisabled(true);
        setSaveText("Сохранено");
        refreshTree();
        setIsSending(false);
    }
    const errorSaveAccount = () => {
        setSaveText("Ошибка");
        refreshTree();
        setIsSending(false)
    }
    const saveAccount = (accToSave) => {
        setIsSending(true);
        centerClient.updateAccount(accToSave as AccountDto)
            .then(() => successSaveAccount())
            .catch(() => errorSaveAccount());
    }
    const handleAccount = (evt) => {
        const name = evt.target.name;
        const val = evt.target.value;
        const newAccount = { ...account };
        newAccount[name] = val;
        setAccount(newAccount);
        handleSaveAccount(newAccount);    
    }
    const handleSaveButton = () => {
        clearTimeout(saveTimeoutRef.current);        
        saveAccount(account);
    }
    return <>
        {
            useIsMobile() ?
            <Mobile account={account} /> :
            <div id="accountInfo" >
                <TextField autoComplete="off" disabled={isSending} name="Login" sx={inputProps} label="Логин" value={account.Login} onChange={handleAccount} placeholder="Логин..." />
                <TextField autoComplete="off" sx={inputProps} label="Пароль" type="input" disabled={isSending} name="Password" onChange={handleAccount} value={account.Password} placeholder="Пароль..." />
                <Button style={{ borderColor: "var(--border)" }} onClick={handleSaveButton} variant="transparent" className={saveButtonDisabled ? "disabled" : ""}>
                    <Floppy2Fill style={{ fill: 'var(--text)' }} />
                </Button>
                <label style={{ marginLeft: "1rem" }}>{saveText}</label>
            </div>
        }
    </>
};

interface IMobileAccountInfoProps{
    account: Account;
}
const Mobile = (props: IMobileAccountInfoProps) => {
    const { account } = props;
    const [open, setOpen] = useState(false);
    const { handleDeleteAccount } = context;
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    return (
        <>
            <Dropdown.Item onClick={handleOpen}>
                <Settings />
                Настройки аккаунта
            </Dropdown.Item>
            <Modal show={open} onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>Настройки аккаунта</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Логин</Form.Label>
                                    <Form.Control className="disabled" type="input" value={account.Login} disabled={true} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Пароль</Form.Label>
                                    <Form.Control type="input" name="Name" value={account.Password} placeholder="Имя..." />
                                </Form.Group>
                            </Col>
                        </Row>                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', marginTop: '.5rem' }}>
                        <Button variant='custom' onClick={handleDeleteAccount}>Удалить аккаунт</Button>
                        <div style={{ display: 'flex', gap: '.5rem' }}>
                            <Button variant="custom" >
                                <Floppy2Fill className="marginRight" />
                                Сохранить
                            </Button>
                            <Button variant="custom" onClick={handleClose}>
                                Закрыть
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
        
    )
}
export default AccountInfo;
